import { render, staticRenderFns } from "./VariableIncomeInvestment.vue?vue&type=template&id=fe404b20&scoped=true"
import script from "./VariableIncomeInvestment.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariableIncomeInvestment.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./VariableIncomeInvestment.vue?vue&type=style&index=0&id=fe404b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe404b20",
  null
  
)

export default component.exports